import { DetailEntity, MainEntity } from "@/script/core/base/IBaseEntity";

export interface Category extends MainEntity {
  sortNo?: number;
  type?: string;
  navType?: string;
  img?: string;
  listTemplate?: string;
  detailTemplate?: string;
  indexTemplate?: string;
  url?: string;
  parentId?: number;
  tagIds?: string;
  customId?: number;
  staticize?: boolean;
  staticizeName?: string;
  nav?: boolean;
  navName?: string;
  checked?: boolean;
  pageSize?: number;
  sortType?: string;
  mobileEnable?: boolean;
  mobileUrl?: string;

  listTemplateId?: number;
  detailTemplateId?: number;
  indexTemplateId?: number;

  parentCategory?: Category;
  childCategorys?: Category[];
}


export interface ContentFile extends DetailEntity {
  name?: string;
  type?: string;
  url?: string;
  size?: number;
  hidden?: boolean;
}

export interface Content extends MainEntity {
  sortNo?: number;
  type?: string;
  title?: string;
  url?: string;
  content?: string;
  img?: string;
  releaseDate?: Date;
  author?: string;
  source?: string;
  keyword?: string;
  released?: boolean;
  red?: boolean;
  categoryId?: number;
  tagIds?: string;
  extendData?: string;
  extend?: any;

  linkType?: string;
  linkId?: number;

  mobileImg?: string;
  mobileUrl?: string;
  mobileContent?: string;

  category?: Category;
  contentFiles?: ContentFile[];
  deleteContentFiles?: ContentFile[];
}


export interface Tag extends MainEntity {
  type?: string;
}

export interface Template extends MainEntity {
  path?: string;
  type?: string;

  client?: string;
  mainTemplateId?: number;
  mainTemplate?: Template;
}

export class NodeItem {
  id = 0;
  label = "";
  children: NodeItem[] | null = null;
}

export interface CertImportSheetResult {
  name?: string;
  total?: number;
  successCount?: number;
  failCount?: number;
}


export interface CertImportResult {
  error?: string;
  aResult?: CertImportSheetResult;
  aaResult?: CertImportSheetResult;
  aaaResult?: CertImportSheetResult;
}
